import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Element: HTMLDivElement;
  Blocks: { default: [] };
}

const WrDividerComponent: TemplateOnlyComponent<Signature> = <template>
  <div
    class='text-grey-medium before:bg-grey-medium after:bg-grey-medium flex items-center gap-2 self-stretch before:h-[1px] before:w-full before:content-none after:h-[1px] after:w-full after:content-none'
  >{{yield}}</div>
</template>;

export default WrDividerComponent;
